import actionTypes from './constants';

/* */
export const setMembership = (data) => (dispatch) => dispatch({
    type: actionTypes.SET_MEMBERSHIP,
    payload: data,
  });

/* */
export const setExercisesList = (list) => (dispatch) => dispatch({
    type: actionTypes.SET_EXERCISES_LIST,
    payload: list,
  });

/* */
export const updateDue = (data) => (dispatch) => dispatch({
    type: actionTypes.UPDATE_DUE,
    payload: data,
  });

/* */
export const openMemberCard = () => (dispatch) => dispatch({
    type: actionTypes.OPEN_MEMBER_CARD,
  });

/* */
export const closeMemberCard = () => (dispatch) => dispatch({
    type: actionTypes.CLOSE_MEMBER_CARD,
  });
